<template>
  <Dialog :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')">
    <div class="dialog">
      <div class="dialog-title">
        <img :src="rewardTitleImg" alt="rewardTitle">
      </div>
      <div class="dialog-content-wrap">
        <div class="reward-list">
          <div class="reward-item">
            <div class="reward-icon-wrap">
              <img class="reward-icon" src="~@/views/act/halloween/assets/img/nangua-small.png" alt="">
            </div>
            <p class="reward-text">+{{ count }}</p>
          </div>
        </div>
        <button type="button" class="reward-ok" @click="emit('update:modelValue', false)">
          {{ t('halloween.rewardConfirm') }}
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../index.vue'
import RewardTitleMap from '@/views/act/halloween/assets/img/rewardTitle'

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['update:modelValue', 'close'])
const { t, locale } = useI18n()

const rewardTitleImg = computed(() => RewardTitleMap[locale.value] || RewardTitleMap.en)
</script>

<style scoped lang="less">
.dialog {
  overflow: hidden;

  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: -10px;

    img {
      height: 65px;
      margin-top: 10px;
    }
  }

  .dialog-content-wrap {
    width: 608px;
    height: 420px;
    margin: 16px auto 0;
    padding: 16px 16px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
}

.reward-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}

.reward-item {
  width: 132px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .reward-icon-wrap {
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: url('~@/views/act/halloween/assets/img/prop-bg.png') no-repeat center center / 100% 100%;
  }
}

.reward-icon {
  width: 90px;
  height: 90px;
  object-fit: contain;
}

.reward-text {
  margin: 8px 0 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.reward-ok {
  flex: none;
  align-self: center;
  border: 0;
  font-weight: 800;
  cursor: pointer;
  background: url('~@/views/act/halloween/assets/img/reward-ok-bg.png') no-repeat center center / 100% 100%;
  width: 267px;
  height: 83px;
  color: #FFFF76;
  font-size: 32px;
}
</style>
